import type { ReactElement } from 'react';
import { TitleContainer, TitleContainerProps } from 'components/TitleContainer';
import type { EmbeddedCompany } from 'types';
import { Box } from '@ff-it/ui';
import { Icon } from 'components/Icon';

type CompanyTitleProps = EmbeddedCompany & TitleContainerProps;

export function CompanyTitle({ id, title, internal_name, kind, ...rest }: CompanyTitleProps): ReactElement {
  return (
    <TitleContainer
      testId={`company-${id}`}
      title={internal_name}
      subtitle={
        <>
          {kind === 'branch' && <Icon icon="diagram-subtask" className="mr-1" />} <Box as="span">{title}</Box>
        </>
      }
      {...rest}
    />
  );
}
